export const thingNames: Record<string, string> = {
	tname_AlbinoSquid: "Polvo albino",
	tname_AlbinoSquidCorpse: "Corpo de polvo albino",
	tname_ArrowMob: "Monstro flecha",
	tname_ArtilleryBomb: "Bomba de artilharia",
	tname_ArtilleryRobot: "Robô de artilharia",
	tname_Ashes: "",
	tname_Barrier: "Barreira",
	tname_BlackBox: "",
	tname_BigContainer: "Caixote grande",
	tname_BigSquid: "Polvo matriarca",
	tname_BigSquidCorpse: "Corpo de polvo matriarca",
	tname_BigSquidTentacle: "Polvo matriarca",
	tname_BigSquidTentacleCorpse: "Tentáculo cortado de polvo matriarca",
	tname_BigSquidTentacleCut: "Polvo matriarca",
	tname_Biter: "Mordedor",
	tname_BiterCorpse: "Corpo de mordedor",
	tname_BlackFloor: "",
	tname_BlastDoor: "Porta de segurança",
	tname_SlidingDoor: "Porta deslizante",
	tname_SlidingGate: "Portão deslizante",
	tname_BloodPool: "Sangue",
	tname_CannonBullet: "Bomba",
	tname_BoxFloor: "",
	tname_BrickWall: "Parede de tijolos",
	tname_BrownFloor: "",
	tname_SolidifierShot: "Bolha",
	tname_AirBlastShot: "Rajada de ar",
	tname_SolidifiedBiter: "Mordedor solidificado",
	tname_SolidifiedHorned: "Monstro com chifre solidificado",
	tname_SolidifiedSlugant: "Slugant solidificado",
	tname_SolidifiedSquid: "Polvo solidificado",
	tname_CryoShot: "Tiro criogênico",
	tname_CaveRock: "Rocha",
	tname_CaveFloor: "",
	tname_CaveRobot: "Robô de caverna",
	tname_CaveRobotCorpse: "Sucata de robô de caverna",
	tname_Chasm: "Abismo",
	tname_ConcreteBlock: "Concreto",
	tname_ConcreteFloor: "",
	tname_Rock: "Rocha",
	tname_RockMobCave: "Caverna",
	tname_DarkConcreteFloor: "",
	tname_DeadPlant: "Planta morta",
	tname_DeskWithComputer: "Mesa de escritório",
	tname_DeskWithMachine: "Máquina",
	tname_DestroyedConcreteBlock: "Destroço de concreto",
	tname_DestroyedRock: "",
	tname_Downstairs: "Escadas para baixo",
	tname_BlackHoleProjectile: "Buraco negro",
	tname_DrillBullet: "Broca",
	tname_MiningRobot: "Robô de mineração",
	tname_PlasmaBall: "Bola de plasma",
	tname_EmptyBarrel: "Barril",
	tname_Equation: "Equação",
	tname_ExplosiveBarrel: "Barril com explosivos",
	tname_Fence: "Cerca",
	tname_FenceLight: "Cerca",
	tname_Fire: "Fogo",
	tname_FireTower: "Torre de fogo",
	tname_FloatingRobot: "Robô flutuante",
	tname_FloatingRobotCorpse: "Sucata de robô flutuante",
	tname_GasBomb: "Bomba de gás",
	tname_Gas: "Gás",
	tname_BileGas: "Gás Biliar",
	tname_GasBarrel: "Barril de gás",
	tname_GoldDrop: "Grana",
	tname_GrassTiledFloor: "",
	tname_GraySlab: "",
	tname_GrayStoneFloor1: "",
	tname_GrayStoneFloor2: "",
	tname_HomingMissile: "Míssil teleguiado",
	tname_InvulnerableBigContainer: "Caixote grande",
	tname_Horned: "Monstro com chifre",
	tname_HornedCorpse: "Corpo de monstro com chifre",
	tname_KeyLootBox: "Chave",
	tname_PowerPlantKeyCardLootBox: "Cartão da usina",
	tname_BaseKeyCardLootBox: "Cartão da base",
	tname_NightVisionLootBox: "Equipamento de visão noturna",
	tname_JetpackLootBox: "Mochila-foguete",
	tname_LadderDown: "Escadas para baixo",
	tname_LadderUp: "Escada para cima",
	tname_Lamp: "",
	tname_Landmine: "Mina terrestre",
	tname_LavaPool: "Lava",
	tname_LevelDown: "Saída para a próxima área",
	tname_LevelUp: "Saída para a área anterior",
	tname_LootBox: "Caixa de itens",
	tname_MachineConnectedToWall: "Máquina",
	tname_MachineRack: "Rack de máquinas",
	tname_LargeMachine: "Máquina grande",
	tname_SlugantCorpse: "Corpo de formilesma",
	tname_Slugant: "Formilesma",
	tname_ToxicSlug: "Lesma tóxica",
	tname_BilePuddle: "Poça de bile",
	tname_ToxicSlugBrokenShell: "Casco quebrado de lesma",
	tname_MedicalLootBox: "Kit médico",
	tname_MetalBlock: "Parede de metal",
	tname_MetalBlockDiagonal: "Parede de metal",
	tname_MetalDoor: "Porta de metal",
	tname_MetalGridFloor: "Piso de grade de metal",
	tname_MetalLootBox: "Caixa de itens de alta qualidade",
	tname_Missile: "Míssil",
	tname_MossBrick: "Parede de tijolos com musgo",
	tname_MossFloor: "",
	tname_MossGate: "Portão",
	tname_OfficeChair: "Cadeira de escritório",
	tname_PlasticCabinet: "Armário de plástico",
	tname_OpenBlastDoorsTerminal: "Terminal",
	tname_PowerPlantGateTerminal: "Terminal",
	tname_PowerPlantSwitch: "Interruptor da usina",
	tname_VendingMachine: "Máquina de venda",
	tname_Plant: "Vegetação",
	tname_Player: "Você",
	tname_PlowRobot: "Robô-arado",
	tname_BossPlowRobot: "Chefe Robô-arado",
	tname_BlackHoleRobot: "Robo Buraco Negro",
	tname_Portal2: "Portal de monstros",
	tname_Amoeba: "Ameba",
	tname_AmoebaCorpse: "Corpo de ameba",
	tname_PottedPlant: "Planta de plástico",
	tname_RareItemsLootBox: "Caixa de itens raros",
	tname_ReinforcedPortal2: "Portal de monstros",
	tname_Robot: "Robô",
	tname_HeavyRobot: "Robô pesado",
	tname_JetpackMob: "Robô com jetpack",
	tname_RobotCorpse: "Sucata de robô",
	tname_EngineerRobot: "Robô Engenheiro",
	tname_EngineerCorpse: "Sucata de robô engenheiro",
	tname_DummyMob: "Manequim",
	tname_DummyMobB: "Manequim B",
	tname_DummyMobCorpse: "Corpo de manequim",
	tname_RobotEntranceTerminal: "Terminal",
	tname_UnbreakableRock: "Rocha",
	tname_RobotSpawner: "Elevador de robôs",
	tname_ScrapMetal: "Sucata de metal",
	tname_Sculpture1: "Escultura",
	tname_ShortSolidifierShot: "Bolha",
	tname_Shrapnel: "Estilhaço",
	tname_Sign: "Placa",
	tname_Smoke: "Fumaça",
	tname_SnakeBody: "Cobra",
	tname_SnakeHead: "Cobra",
	tname_Spreader: "Musgo",
	tname_Squid: "Polvo",
	tname_SquidCorpse: "Corpo de polvo",
	tname_Tomb: "Lápide",
	tname_Tree: "Árvore",
	tname_Upstairs: "Escadas acima",
	tname_WallCrack: "",
	tname_WarningFloor: "",
	tname_WavyTile: "",
	tname_TornGround: "",
	tname_WaterTile: "Água",
	tname_WinConditionTerminal: "Terminal",
	tname_WoodenBridgeFloor: "",
	tname_WoodenCabinet: "Gaveta de madeira",
	tname_WoodenDesk: "Mesa de madeira",
	tname_WoodenDoor: "Porta",
	tname_WoodenFloor: "",
	tname_WoodenShelf: "Prateleira",
	tname_ZooReleaseTerminal: "Terminal",
};
